import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  ApiClient,
  CreateApiClientRequest,
  UpdateApiClientRequest,
} from "../models/ApiClient";

export const ApiClientApi = {
  create: async (body: CreateApiClientRequest) => {
    return await jwtAuthAxios().post<ApiClient>(`/api-clients`, body);
  },

  update: async (apiKeyId: string, body: UpdateApiClientRequest) => {
    return await jwtAuthAxios().put<ApiClient>(
      `/api-clients/${apiKeyId}`,
      body
    );
  },

  delete: async (apiKeyId: string) => {
    return await jwtAuthAxios().delete(`/api-clients/${apiKeyId}`);
  },
};
